import {
  type BillingStatus,
  iterationsRemaining,
} from "../components/BillingStatusContext";

/**
 * Show the header pill only once the allowance is nearly gone. Free users get
 * a runway to act on rather than a permanent counter nagging from day one.
 */
export const LOW_ITERATIONS_THRESHOLD = 10;

/**
 * Label for the header iteration pill, or null when it shouldn't render —
 * for subscribers, signed-out visitors, while billing loads, and for free
 * users who still have plenty of allowance left.
 */
export function getIterationCountLabel(
  billingStatus: BillingStatus | null,
  isBillingLoading: boolean,
): string | null {
  if (isBillingLoading || !billingStatus) return null;
  if (billingStatus.has_active_subscription) return null;

  const remaining = iterationsRemaining(billingStatus);
  if (remaining > LOW_ITERATIONS_THRESHOLD) return null;

  return `${remaining} Visualization${remaining === 1 ? "" : "s"} Left`;
}
